const getMin = (x, y) => (x < y ? x : y)

export default getMin
